// extracted by mini-css-extract-plugin
export default {"second_part":"second_second_part__rQM9y","second":"second_second__HwjcR"};